// module augementation import
import type {} from '@mui/x-date-pickers/themeAugmentation';
import { ComponentsProps } from '@mui/material';

export const MuiDatePicker: {
    defaultProps?: ComponentsProps['MuiDatePicker'];
} = {
    defaultProps: {
        displayWeekNumber: true,
    },
};
